import { render, staticRenderFns } from "./commonSubFolder.vue?vue&type=template&id=989b2128&scoped=true"
import script from "./commonSubFolder.vue?vue&type=script&lang=js"
export * from "./commonSubFolder.vue?vue&type=script&lang=js"
import style0 from "./commonSubFolder.vue?vue&type=style&index=0&id=989b2128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989b2128",
  null
  
)

export default component.exports